import React from 'react';
import { Box, Typography } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { palette } from '../../styles/theme';
import { isToday as checkIsToday } from '@core/helpers/CalendarHelpers';

/**
 * CustomCalendarDay - Internal component to render each calendar day
 *
 */
export function CustomCalendarDay ({
    day,
    outsideCurrentMonth,
    selectedDate,
    dayData,
    renderDay,
    dayProps = {},
    ...other
}) {
    const isToday = checkIsToday(day);

    return (
        <PickersDay
            {...other}
            day={day}
            outsideCurrentMonth={outsideCurrentMonth}
            selected={false}
            disableRipple
            sx={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                padding: '0.62rem',
                border: isToday
                    ? `0.15rem solid ${palette.success[500]}`
                    : `0.08rem solid ${palette.disabled[200]}`,
                borderRadius: '0.31rem',
                backgroundColor: outsideCurrentMonth
                    ? palette.disabled[50]
                    : isToday
                        ? palette.success[50]
                        : palette.white,
                cursor: 'default',
                '&:hover': {
                    backgroundColor: outsideCurrentMonth
                        ? palette.disabled[100]
                        : isToday
                            ? palette.primary[100]
                            : palette.beige[50],
                },
                '&.Mui-selected': {
                    backgroundColor: isToday
                        ? `${palette.success[50]} !important`
                        : `${palette.white} !important`,
                    border: isToday
                        ? `0.15rem solid ${palette.success[500]}`
                        : `0.08rem solid ${palette.disabled[200]}`,
                    '&:hover': {
                        backgroundColor: isToday
                            ? `${palette.success[100]} !important`
                            : `${palette.beige[50]} !important`,
                    }
                },
                ...(dayProps.sx || {})
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {/* Day number */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        marginBottom: '0.31rem',
                    }}
                >
                    <Box
                        sx={{
                            width: '2.15rem',
                            height: '2.15rem',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: isToday ? palette.primary.main : 'transparent',
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: isToday ? 700 : 500,
                                color: isToday
                                    ? palette.white
                                    : outsideCurrentMonth
                                        ? palette.disabled[400]
                                        : palette.disabled[900],
                            }}
                        >
                            {day.getDate()}
                        </Typography>
                    </Box>
                </Box>

                {/* Custom content */}
                {!outsideCurrentMonth && dayData && renderDay && (
                    <Box sx={{ width: '100%', flex: 1 }}>
                        {renderDay(dayData, day, isToday)}
                    </Box>
                )}
            </Box>
        </PickersDay>
    );
}
